// extracted by mini-css-extract-plugin
export default {"container":"Notifs_container__ghsWx","new":"Notifs_new__HqVdE","row":"Notifs_row__--AIi","col":"Notifs_col__R6gDo"};